export default "__VITE_ASSET__DuJNehIL__"